import OverlayWithTimer from './OverlayWithTimer';

export default OverlayWithTimer;
